import connectToStores from 'alt-utils/lib/connectToStores'
import { Nav, Loading, Details, NotFoundDetails } from 'components'
import { CheckActions, CheckDetailActions } from 'actions'
import Helmet from 'react-helmet'
import Enum from 'utils/Enum'

import {
  CheckStore,
  CheckDetailStore,
  UserFeedbackStore
} from 'stores'

@connectToStores
export default class DetailsContainer extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  }

  static propTypes = {
    params: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    let key = props.params.key.toLowerCase()
    let checkType = Enum.CheckTypes[key]
    this.state = { checkType }
  }

  componentWillMount() {
    CheckActions.fetch()
    const adhocUrl = this.props.location.query.ah

    if (adhocUrl)
      CheckDetailActions.fetchAdhoc.defer(this.state.checkType.id, adhocUrl)
    else
      CheckDetailActions.fetch.defer({ id: this.state.checkType.id, refresh: false })
  }

  static getStores() {
    return [
      CheckStore,
      CheckDetailStore,
      UserFeedbackStore
    ]
  }

  static getPropsFromStores() {
    return {
      ...CheckStore.getState(),
      ...CheckDetailStore.getState(),
      ...UserFeedbackStore.getState()
    }
  }

  render() {
    const check = this.props.checks.toJS().find(x => x.key === this.state.checkType.key)
    const exceptionExists = this.props.result && !this.props.result.isEmpty() && this.props.result.get('exception')

    const shouldRenderChecking = (!check && !exceptionExists) ||
      !this.props.result ||
      this.props.result.isEmpty() ||
      (
        this.props.result &&
        !exceptionExists &&
        this.state.checkType.advisorType !== this.props.result.toJS().type
      )

    if (shouldRenderChecking) {
      return (
        <div>
          <Helmet title={`Plug in SEO - ${this.state.checkType.name}`} />
          <Nav toolbarTitleText={`Checking ${this.state.checkType.name}...`}/>
          <Loading />
        </div>
      )
    }

    return (
      <div>
        <Helmet title={`Plug in SEO - ${this.state.checkType.name}`} />
        {
          check && this.state.checkType.key === Enum.CheckTypes.notfound.key &&
            <NotFoundDetails
              check={check}
              checkType={this.state.checkType}
              result={this.props.result}
              feedbackDismissed={this.props.feedbackDismissed}
              isEnjoying={this.props.isEnjoying}
              willReview={this.props.willReview}
              willFeedback={this.props.willFeedback}
            />
        }
        {
          this.state.checkType.key !== Enum.CheckTypes.notfound.key &&
            <Details
              checkType={this.state.checkType}
              result={this.props.result}
              adhocUrl={this.props.adhocUrl}
              feedbackDismissed={this.props.feedbackDismissed}
              isEnjoying={this.props.isEnjoying}
              willReview={this.props.willReview}
              willFeedback={this.props.willFeedback}
            />
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/DetailsContainer.js